/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlMappingResponse {
    getFixupPrototypeFunction() { return ComplianceControlMappingResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlMappingResponse>): ComplianceControlMappingResponse {
        let obj = Object.assign(new ComplianceControlMappingResponse(), model);
        ComplianceControlMappingResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlMappingResponse>): ComplianceControlMappingResponse {
        if (!model) return null;
        return ComplianceControlMappingResponse.newInstance(<ComplianceControlMappingResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlMappingResponse) {
        if (!obj) return;

        models.ComplianceControlMappingResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlMappingResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceControlMappingResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * compliance control mappings list
     */
    message: string;

    /**
     * data for compliance control mappings list
     */
    data: any;

}
